// extracted by css-extract-rspack-plugin
export default {"selected":"XTdqs"};